var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-doctors",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-doctors:not(.animated) .animable {opacity: 0;}svg#freepik_stories-doctors.animated #freepik--background-simple--inject-2 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-doctors.animated #freepik--Icons--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-doctors.animated #freepik--character-3--inject-2 {animation: 0.8s 1 forwards ease-in slideRight;animation-delay: 1s;opacity: 0}svg#freepik_stories-doctors.animated #freepik--character-2--inject-2 {animation: 0.8s 1 forwards ease-in slideDown;animation-delay: 0s;}svg#freepik_stories-doctors.animated #freepik--character-1--inject-2 {animation: 0.8s 1 forwards ease-in slideLeft;animation-delay: .5s;opacity: 0}            @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2",
    className: "animable",
    style: {
      transformOrigin: "248.297px 261.286px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.19,75.75s-75.77,38.61-113.56,98.1-34.8,136,11.12,192.78S196.44,416,269.93,452s154.57,28.58,189.32-47.66S441.6,299.57,432.6,211.36,344.07-6,165.19,75.75Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "248.297px 261.286px"
    },
    id: "elsa2aavkgq0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltxveolnfp9o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.19,75.75s-75.77,38.61-113.56,98.1-34.8,136,11.12,192.78S196.44,416,269.93,452s154.57,28.58,189.32-47.66S441.6,299.57,432.6,211.36,344.07-6,165.19,75.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "248.297px 261.286px"
    },
    className: "animable",
    id: "el0axbpyqylolf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-2",
    className: "animable",
    style: {
      transformOrigin: "251.381px 179.041px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.2,273.5h-4.15v-.71a7.32,7.32,0,0,0-7.31-7.31h-2.81a7.32,7.32,0,0,0-7.32,7.31v.71h-4.14a4.2,4.2,0,0,0-4.21,4.21v19.18a4.21,4.21,0,0,0,4.21,4.21H467.2a4.22,4.22,0,0,0,4.21-4.21V277.71A4.21,4.21,0,0,0,467.2,273.5Zm-19.59-.71a5.32,5.32,0,0,1,5.32-5.31h2.81a5.31,5.31,0,0,1,5.31,5.31v.71H447.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "454.335px 283.29px"
    },
    id: "eluik3y4xrw8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462 285.34 456.7 285.34 456.7 280.05 451.96 280.05 451.96 285.34 446.66 285.34 446.66 290.09 451.96 290.09 451.96 295.38 456.7 295.38 456.7 290.09 462 290.09 462 285.34",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "454.33px 287.715px"
    },
    id: "el91zbk02kapu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,159.2h0a6.27,6.27,0,0,1-6.27-6.28V136a6.27,6.27,0,0,1,6.27-6.28h0a6.27,6.27,0,0,1,6.27,6.28v16.89A6.27,6.27,0,0,1,459,159.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "459px 144.46px"
    },
    id: "elv313z1nxuca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,159.2h0a6.27,6.27,0,0,1-6.27-6.28v-8.45h12.54v8.45A6.27,6.27,0,0,1,459,159.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "459px 151.835px"
    },
    id: "elsyi74f4k478",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.46,134.28h0a6.26,6.26,0,0,1,1-8.82l13.17-10.58a6.29,6.29,0,0,1,8.83,1h0a6.28,6.28,0,0,1-1,8.82l-13.18,10.57A6.27,6.27,0,0,1,427.46,134.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "438.956px 125.079px"
    },
    id: "elloqcxd872j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.46,134.28h0a6.26,6.26,0,0,1,1-8.82l6.59-5.29,7.85,9.79-6.59,5.28A6.27,6.27,0,0,1,427.46,134.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "434.493px 128.405px"
    },
    id: "ely6173q7e9yb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.75,88.24a3.75,3.75,0,0,0-2.18.7L348,77.63a8.15,8.15,0,0,0-.46-8.5l8.9-11.38a3.78,3.78,0,1,0-2.42-3.52,3.69,3.69,0,0,0,.69,2.17l-8.66,11.09a8.17,8.17,0,0,0-13.42,5.8H322.51a3.78,3.78,0,1,0-.39,2.19h10.7a8.18,8.18,0,0,0,13.92,3.92l14.49,11.27a3.77,3.77,0,1,0,3.52-2.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.751px 73.1116px"
    },
    id: "elxqer1jic0wn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.78,159.32h0a4.58,4.58,0,0,1-4.57-4.57v-38h9.14v38A4.57,4.57,0,0,1,68.78,159.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "68.78px 138.035px"
    },
    id: "elc3iign1et3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.78,159.32h0a4.58,4.58,0,0,1-4.57-4.57V131.38h9.14v23.37A4.57,4.57,0,0,1,68.78,159.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "68.78px 145.35px"
    },
    id: "ely6ultrvj4md",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.91,
    y: 114.53,
    width: 11.75,
    height: 3.33,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "68.785px 116.195px"
    },
    id: "elmgbkzqezpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93,159.32h0a4.58,4.58,0,0,1-4.57-4.57v-38H59.5v38A4.57,4.57,0,0,1,54.93,159.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "54.93px 138.035px"
    },
    id: "elu06yal7w42",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93,159.32h0a4.58,4.58,0,0,1-4.57-4.57V131.38H59.5v23.37A4.57,4.57,0,0,1,54.93,159.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "54.93px 145.35px"
    },
    id: "elbb91pm5m1lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.06,
    y: 114.53,
    width: 11.75,
    height: 3.33,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "54.935px 116.195px"
    },
    id: "elm5xjz95a0tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78,77.07l3.64-8.74a.77.77,0,0,1,.73-.46.75.75,0,0,1,.68.53l4.41,14.54,3.36-10.71a.75.75,0,0,1,.7-.53.8.8,0,0,1,.72.5l1.87,5.38H213a12.21,12.21,0,0,0,3.38-8A11.33,11.33,0,0,0,194,67a11.33,11.33,0,0,0-22.36,2.59,12.36,12.36,0,0,0,2.95,7.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.01px 70.556px"
    },
    id: "elrzetyyxl3nq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.36,79.08a.75.75,0,0,1-.71-.5l-1.3-3.74-3.41,10.87a.76.76,0,0,1-.72.53h0a.74.74,0,0,1-.71-.54L191,70.83l-3,7.28a.75.75,0,0,1-.69.46H175.8c2.47,2.76,5.55,5.2,7.85,7.47,3.48,3.44,6.89,7,10.44,10.32,4.55-4.49,9.13-9,13.64-13.49,1.25-1.25,2.61-2.49,3.87-3.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.7px 83.595px"
    },
    id: "ellesemx6ven",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell4qbqmfinb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.2,
    y: 287.7,
    width: 5.19,
    height: 16.19,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "38.795px 295.795px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "el6j92d42qjg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhhpg5e71p0c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.63,
    y: 303.36,
    width: 8.01,
    height: 3.05,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "35.635px 304.885px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "el3e3jprn7lkw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx49ts3lex2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.04,
    y: 264.83,
    width: 12.83,
    height: 29.33,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "44.455px 279.495px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "elxdagbxlxjv"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellr4i4k2fztc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.87,
    y: 265.19,
    width: 9.47,
    height: 16.19,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "46.605px 273.285px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "eliaj4hj4dw3g"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnyt2d0eby"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.4,
    y: 275.58,
    width: 5.19,
    height: 16.19,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "42.995px 283.675px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "ellbg4e7gol7m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc9ro85xaxmp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.91,
    y: 289.78,
    width: 14.66,
    height: 3.67,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "40.24px 291.615px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "elmrgfkahcex"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elahgm3868isp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.74,
    y: 259.44,
    width: 7.64,
    height: 4.89,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "50.56px 261.885px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "elh7kn3vbdjya"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el025eysl2xpg2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.23,
    y: 262.94,
    width: 14.66,
    height: 3.67,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "49.56px 264.775px",
      transform: "rotate(-160.87deg)"
    },
    className: "animable",
    id: "elecf00bv3b5j"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 51.42,
    y1: 258.95,
    x2: 57.22,
    y2: 242.21,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "54.32px 250.58px"
    },
    id: "elz6mzf3os5na",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2",
    className: "animable",
    style: {
      transformOrigin: "382.147px 284.799px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.9,
    cy: 455.2,
    rx: 52.33,
    ry: 11.8,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.9px 455.2px"
    },
    id: "elazioa5g483",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,188.48s-7.08,4.33-7,6.23-2.64,36.55-2.95,40.88-4.43,13.27-4.75,17.33.7,8.13,1.89,10,5.56,7.85,5.56,7.85l11.75-18.15a103.73,103.73,0,0,0,.18-11.91C338.05,232.06,333.55,188.48,333.55,188.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "328.557px 229.625px"
    },
    id: "el8kju4hnaixj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,102.62s-12.5-.8-19.62,7.87-5.59,21.93-5.64,26-12.14,16-10.8,20.86,4.9,5.41,3.76,9.47-8.58,6.5-7.5,11.65,5,12.45,5,12.45l72,.49s2.57-7.58-.17-13.27-6.63-7.57-6-10.28,4.11-9.21,2.77-14.08-6-6.22-6.49-14.89-1.77-23-8.65-30S378.76,102.62,378.76,102.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "377.953px 147.004px"
    },
    id: "elhdxn5j5onq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,436.73a64,64,0,0,1-8,11.92c-4.6,5.15-9.06,7.86-8.91,10.57s10.19,3.24,15.5,1.34,9.17-5.69,10.24-6,4.06,0,4.13-3.8-.51-14.62-.51-14.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "354.646px 448.915px"
    },
    id: "elxmo57bhw6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19,460.56c5.32-1.9,9.17-5.69,10.24-6s4.06,0,4.13-3.8c0-2-.11-6-.25-9.27a9.45,9.45,0,0,1-8.1,5s-.1-1.9-3-5.14c-1.87-2.12-3.76-.45-4.86,1l-.89,1.34-.07.13h0a48,48,0,0,1-3.78,4.87c-4.6,5.15-9.06,7.86-8.91,10.57S349.88,462.46,355.19,460.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "354.628px 451.024px"
    },
    id: "elecer8nnvg45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.67,436.71a74.28,74.28,0,0,0,9.3,11.91c5.15,5.14,9.9,7.84,10,10.55s-9.84,3.25-15.36,1.36-9.78-5.68-10.87-5.95-4.07,0-4.54-3.78-1.06-14.62-1.06-14.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "397.055px 448.914px"
    },
    id: "elxvmzh42l6d9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.65,460.53c-5.51-1.89-9.78-5.68-10.87-5.95s-4.07,0-4.54-3.78c-.25-2-.53-6-.74-9.28a10.6,10.6,0,0,0,8.63,4.94s-.1-1.9,2.43-5.15c1.65-2.11,3.72-.45,5,1,.33.44.67.88,1,1.34l.09.13h0a59.77,59.77,0,0,0,4.3,4.87c5.15,5.14,9.9,7.84,10,10.55S403.17,462.42,397.65,460.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "397.225px 450.984px"
    },
    id: "elq6v4ui63tk9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.87,293.8s1.67,56.31,3.89,67.41,12.13,74.72,12.13,74.72a23.81,23.81,0,0,0,9.58,1.88H371.3l1-47.38.37-68.77,5.43,116.41s14.92.53,16.53.26,2.95-.54,2.95-.54l9.59-73.65,5.49-49,.3-19.49s-45.84-1.59-59.16-2.67S335,291.63,335,291.63Z",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.915px 365.018px"
    },
    id: "el61x6thljq49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.77,393.22c-.12.94-.24,1.81-.38,2.61",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "396.58px 394.525px"
    },
    id: "elw86vrwj2vh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,325.43s.93,40.12-.7,61.9",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "397.782px 356.38px"
    },
    id: "eldul6qhf8kw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.85,322.21s1.15,26.54,2.29,32.49",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "349.995px 338.455px"
    },
    id: "elwk4o0e1jmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.58,305.3v20.26a43.83,43.83,0,0,0,7.93,1.37c4.11.27,11.78,0,11.78,0l.55-7.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "401.71px 316.175px"
    },
    id: "el3t3c46u9ihw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,320.9s10.41,3.29,14.79,3.56,8.48.82,8.48.82l-.54-5.47-23.28-2.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "347.08px 321.45px"
    },
    id: "el76327m2xgy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.32,167.07l-8.17,9.21-22.66,16.53L341.32,293s18.06,4.86,33.56,6.21,35.43-2.2,35.43-2.2l-2.93-105s-8.82-13-13.34-16.51-6.59-6.76-12.58-7.3S367.32,167.07,367.32,167.07Z",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.4px 233.293px"
    },
    id: "elehi3cuf809e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.84,172l-24.29,16.53,3.81,60.91-1.29,6.12-10.21,11.76,4.35,20.66-1.94,29.15s9.65,3.25,16.19,4.05a142.42,142.42,0,0,0,14.66.81l.84-39.8s3.23-66.07,3.61-69,3.75-46,3.75-46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "346.59px 244.59px"
    },
    id: "elywy8uuri6x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "358.23 174.49 346.47 203.98 359.16 209.25 347.18 211.43 357.79 253",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "352.815px 213.745px"
    },
    id: "el1m3rukm69ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.28,159.22s4.22,28.15,7.54,34.65,4.26,8.66,4.26,8.66,7.22-21.94,8.67-25.19,3-14.89,3-14.89S374.36,167.06,365.28,159.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "377.015px 180.875px"
    },
    id: "el8283sdujvd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.28,159.22s.38,2.56,1,6.31c2.11,1.61,7.7,5.59,11.83,5.8,3.15.16,7.15-1.88,9.81-3.51.48-2.95.81-5.37.81-5.37S374.36,167.06,365.28,159.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "377.005px 165.279px"
    },
    id: "elvnzuq94xqmm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,139.76s-2.88-4.1-4.82,0,3,10.17,4.38,11c3.92,2.33,2.88-2,2.88-2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "358.2px 144.693px"
    },
    id: "el4sdzzbvjc2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.32,141.53s2.43-4.24,4.81-.24-1.91,10.29-3.19,11.18c-3.66,2.53-3.08-1.81-3.08-1.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "397.332px 146.417px"
    },
    id: "eltugfkxqpf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,136.14s10.44-2.44,15.7-5.55a28.82,28.82,0,0,0,8.27-7.53s4.52,8.54,8.5,12,4.81,3.66,4.81,3.66-1.91,14.95-4.07,20.15-9.21,10.26-15.79,8.8c-3.74-.82-10.22-3.52-12.1-8.07S358.87,136.14,358.87,136.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "377.51px 145.492px"
    },
    id: "el9qfls0u6ujn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.51,147.63c-3.24.08-14.09.1-19.69-3.28a37.17,37.17,0,0,1-6.27-4.59c.2,1,.44,2.25.7,3.55l1.22.89,3.06,11.56-1.43.31a34.62,34.62,0,0,0,1.09,3.49c1.88,4.55,8.36,7.25,12.1,8.07,6.57,1.45,13.6-3.58,15.78-8.77a4.93,4.93,0,0,1-.43-3.27c.63-3.27,1.41-9,1.41-9l2.23-2c.12-.73.22-1.43.32-2.07C392.9,144.39,387.84,147.57,385.51,147.63Z",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "377.575px 153.822px"
    },
    id: "elrczq98s8nfd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6,142.8s-3.49-4.24-8.07-3.85",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "369.565px 140.862px"
    },
    id: "el9n2094smt6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.59,143.64a9.89,9.89,0,0,1,8.79-2.94",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "386.985px 142.103px"
    },
    id: "el6arutcf71dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,136.83s5-2,9.43-1.06",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "368.235px 136.174px"
    },
    id: "elky2amtgghxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,136.86a7.21,7.21,0,0,1,8.19,1.14",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "387.095px 137.035px"
    },
    id: "elraq3z0uzf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.24,141.41a1.18,1.18,0,0,1-1,1.34,1.24,1.24,0,0,1-1.1-1.29,1.17,1.17,0,0,1,1-1.34A1.25,1.25,0,0,1,370.24,141.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.189px 141.435px"
    },
    id: "el15507hsvv2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35,142.71a1.15,1.15,0,0,1-1,1.34,1.23,1.23,0,0,1-1.1-1.28,1.15,1.15,0,0,1,1-1.34A1.23,1.23,0,0,1,388.35,142.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "387.3px 142.74px"
    },
    id: "elqlgvga53708",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.28,182.74s5.83,2.7,8,7,19.52,50.89,19.44,54.41-5.82,7.58-11.2,8.13-13.22-9.2-14.39-10.82-1.38-20.58-1.38-20.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "429px 217.521px"
    },
    id: "el1pkoy7l5zpy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.8,170.3l2.84,93.14,1,58.75a74.65,74.65,0,0,0,16.63,2.15,35.42,35.42,0,0,0,13.68-2.44s-1.7-36.55-2-42.51-2.28-17.33-2.28-17.33l-2.36-79.32S393.34,172.46,387.8,170.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "404.875px 247.324px"
    },
    id: "el2fvhko3v1uy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "394.04 175.44 404.11 208.29 394.93 210.78 403.86 215.11 392.72 250.5",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "398.415px 212.97px"
    },
    id: "elfzw6hh1uqwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.06,205.49l-12.49,59.84s8.54,2.7,14.78,3,19.24.26,19.24.26l13-55.78S410,210.36,401.06,205.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "412.08px 237.041px"
    },
    id: "elhawvy9q7rw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,261.26l.41-18.7,9.91,2.09S409.18,259.08,405.41,261.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "410.57px 251.91px"
    },
    id: "eljhxd7lolae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,235.8s-2.64-3.78-3.49-4.6-5.05-3.24-5.86-3.24-5.16-.27-6-.27-1.79,1.9-.93,2.71,3.85,1.08,3.85,1.08l2.05,3-9.25-.81s-1.54,1.63-1.19,3a18.41,18.41,0,0,0,1,2.71,42.77,42.77,0,0,0,.31,5.95c.36,1.63,2,2.17,4.25,3.52s9.78.54,9.78.54H411Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "402.564px 238.66px"
    },
    id: "el0t5u5u0pnkt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.55,237.68l-24-3.23s-1.87,15.44-3.76,20.58-2.38,6.23-2.38,6.23,25.15-.56,31.08-1.1,9.26-4.07,9-8.94-3.23-9.75-3.23-9.75",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "425.457px 247.855px"
    },
    id: "elz09p2c460hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,254.54s5.6,3.51,7,4.6,1.52,8.12,2.41,9.47-.16,2.17-1.78,2.17-4.07-5.14-4.07-5.14l-.1-1.9-11.44,3.8-3-5.14S327.89,254.54,335.47,254.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "334.848px 262.66px"
    },
    id: "elh8vtgwg86ot",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    className: "animable",
    style: {
      transformOrigin: "247.016px 270.876px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.13,
    cy: 455.2,
    rx: 52.33,
    ry: 11.8,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "252.13px 455.2px"
    },
    id: "el7pt6tpe205q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,174.79s6.86,34.43,8.08,40.8,3.46,21.51,6,28.15,1.71,15.14.44,17.53a39.59,39.59,0,0,1-4.37,5.84L294.63,256s-5.07-54.44-5.26-62.15S293,174.79,293,174.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "299.048px 220.95px"
    },
    id: "elh7bgpu0u6k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.52,254.64s5.4,3.37,6.35,4.8,1.63,3.25.89,4.8-4.77,6.23-5.79,7.14-1.88-2.72-2-5.84S297.52,254.64,297.52,254.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "301.015px 263.081px"
    },
    id: "el4ppb580072e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.48,443.44s16.93,8.23,18,9.83S283.69,457,273.6,457s-10.39-1.33-14.4-2.39-12-.27-13.08-2.66.8-10.62.8-10.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266.219px 449.165px"
    },
    id: "eliyvwrmcrfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,447.69s14,8.5,12.77,11.42-11.35,2.92-16.68,2.12-16.66-8-17.26-10.62.9-6.64,9.11-7.43S246,447.69,246,447.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "241.779px 452.393px"
    },
    id: "elc6igdik4cri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,308.8s-8,61.61-9.39,70.64-5.8,23.37-8.18,34.26a181.53,181.53,0,0,0-3,19.39,18.18,18.18,0,0,0,.13,5.57c.34,2.66.39,4.78.39,4.78a72.54,72.54,0,0,1-10.84,1.86c-4.51.27-10.62.27-10.62.27l-2-17.26s1.49-25.5,2.37-32.93,1.82-65.86,1.78-67.46-.39-15.67-.39-15.67L276,309.33s3.72-10.62,9.31-10.09S288.5,308.8,288.5,308.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "267.001px 372.395px"
    },
    id: "elmqoyso7z3u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,299.24c-5.59-.53-9.31,10.09-9.31,10.09l-27.28,2.92s.09,3.74.18,7.58c2.91.26,5.6.41,7.9.41A240.45,240.45,0,0,0,283,318.77l1.17-12.24L286,319l1.26-.41c.78-5.94,1.28-9.81,1.28-9.81S290.94,299.77,285.35,299.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "268.906px 309.73px"
    },
    id: "el74ll170a6u7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.3,310.66s0,.38.06,1.07c.37,7.26,2.57,49.33,3.24,57.09.75,8.5-3,17.79-2.81,25.49s2,49.4,2,49.4l2,6.9s4.7-3.18,9.21-3.18,12,.26,12,.26.39-5.58.35-7.43-.21-8.5-.21-8.5,7.63-34.79,8.09-37.71,6.38-53.38,6.34-55,1.25-24.17,1.25-24.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "241.06px 380.635px"
    },
    id: "el1t6rm19h7eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.54,320.19c.17-3.08.29-5.28.29-5.28l-41.53-4.25s0,.38.06,1.07c0,.88.11,2.27.21,4,9.71,1.74,26.56,4.48,36.27,4.48C258.44,320.24,260,320.22,261.54,320.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "241.065px 315.442px"
    },
    id: "el6xk9eklfmov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,147.6s-4.39.74-6.06,2.7a44,44,0,0,0-4.5,6.12c-.23.74-26.05,16.41-26.05,16.41l1.86,74.72s.77,11.51-.6,15.43a79,79,0,0,0-3.33,23.77c.24,9.55.86,25,.86,25s29.55,5.88,43.76,5.88A240.45,240.45,0,0,0,283,316.14l1.17-12.25,1.78,12.5,6.07-2,5-37s3.48-7.84,3.44-9.56.88-3.92-.13-5.39-2.81-4.41-2.81-4.41S293,177,293,174.79s-13.37-15.18-14.36-15.67-7.09-9.56-15-12S250.9,147.6,250.9,147.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.509px 231.889px"
    },
    id: "el0hkcbogyo1hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242.85 158.87 239.89 185.78 252.05 191.43 249.01 200.56 279.42 254",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "259.655px 206.435px"
    },
    id: "elhixqpxjorar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "276.82 161.89 285.94 183.18 282.03 188.39 288.55 197.51 285.94 256.17",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "282.685px 209.03px"
    },
    id: "eletk6c6btfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.77,151.28a56.54,56.54,0,0,0,2.83,15.43c2.63,7.35,20.06,58.06,20.06,58.06l11.27,39.68s-1.49-40.42-1.53-42.13-8.54-57.82-8.54-57.82-1.45-9.06-3.74-12.49S252.48,142.21,249.77,151.28Z",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266.85px 205.535px"
    },
    id: "elv5wshh7686b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.69,147.36s-7.09.73-5.84,11.51,2.9,18.13,2.9,18.13",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "245.696px 162.18px"
    },
    id: "el6p02ef8kupg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,191.21s3,12.49,5.05,15.92,8.25,6.86,12.66,6.86",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "253.735px 202.6px"
    },
    id: "el5x8tvincdko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,188.27s3.3,14.45,3.85,17.15-1.27,7.83-4.33,13",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.094px 203.345px"
    },
    id: "el9a7g6blldfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,220.13h0a1.36,1.36,0,0,1-.54-1.84l.35-.64a1.32,1.32,0,0,1,1.82-.49h0a1.37,1.37,0,0,1,.55,1.84l-.35.63A1.33,1.33,0,0,1,253,220.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.817px 218.644px"
    },
    id: "elm1095h6qrcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.23,214.26h0a1.31,1.31,0,0,1-1.36,1.31l-.73,0a1.37,1.37,0,0,1-1.34-1.38h0a1.3,1.3,0,0,1,1.35-1.31l.73,0A1.39,1.39,0,0,1,264.23,214.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.515px 214.225px"
    },
    id: "els9i6qew0da",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9,192.19l-1.68-10.65a4.38,4.38,0,0,1,3.31-5h0a4.63,4.63,0,0,1,5.5,3.32l2.87,10.6",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "249.029px 184.307px"
    },
    id: "el1033evdf9dd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluzt483djb3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.94,
    cy: 194.34,
    rx: 4.38,
    ry: 5.05,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.94px 194.34px",
      transform: "rotate(-5.72deg)"
    },
    className: "animable",
    id: "el6zi3gpu7565"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.13,151.85s9.63,13.55,12.7,41.17",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "278.48px 172.435px"
    },
    id: "eltv8mpxjtvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elixkjkz4mrwf"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.84,
    cy: 193.42,
    rx: 2.39,
    ry: 2.79,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "284.84px 193.42px",
      transform: "rotate(-5.31deg)"
    },
    className: "animable",
    id: "elb5dzqnxzt1m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.16,256.75a49.77,49.77,0,0,0-1.45,5.58c0,.8-.19,3.19-2.06,2.65s-1.31-10.09-1.07-11.15,4.79,2.37,4.79,2.37",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "296.841px 259.343px"
    },
    id: "elwtu3gx04d4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,248.29a11.89,11.89,0,0,0,5.42,1.47c2.94,0,8.31-1,10.28-.49s7,6.85,7,6.85,1.5,1.47.79,2.21-2.16,2-3.16,1.22-6-4.9-6-4.9l-12.61,5.15L235,257.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "248.57px 254.045px"
    },
    id: "elxaqxqvuenbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.15,171.12s-8.31,1-9.72,3.18-24.18,52.18-24.13,54.39,45.53,38,45.53,38L240.65,248l-24.57-22.78,10.66-24.74",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "212.975px 218.905px"
    },
    id: "elq9ytp357ek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "234.48 275.72 258.5 276.21 258.38 261.27",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "246.49px 268.74px"
    },
    id: "eltv9tuxcezk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.21,
    y1: 259.8,
    x2: 233.86,
    y2: 262.17,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "237.035px 260.985px"
    },
    id: "elubrb766p2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,136.82s2.73,21.32,4.53,24.5,14.6,15.92,14.6,15.92,4-14.69,4.45-18.12.8-17.15.8-17.15l-24.43-6.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "259.615px 156.175px"
    },
    id: "eln3qbw9lsqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,136.82s.32,2.5.81,5.91a24.53,24.53,0,0,0,6.48,4.34c3.15,1.39,11.55,2.17,16.86,1.55.14-3.59.23-6.65.23-6.65l-24.43-6.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "259.615px 141.973px"
    },
    id: "el0tholm9bmhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,118.21s-3.27-3.43-4.89.48,2,9.8,3.93,10.05a8.52,8.52,0,0,0,3.42-.25s1.37,5.64,2.63,7.35a25.68,25.68,0,0,0,9.28,7.34c4.46,2,19.39,2.71,21.28,0s1.78-17.15,1.75-18.37-.24-18.68-.24-18.68,1.34-6.06-.48-10.23-20.09-10-24.68-7.59-9.88,6.61-10.24,12-.14,14.21-.14,14.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.54px 116.351px"
    },
    id: "elu1fq99zba6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.37,110.61s3.05,14,2.35,15.68-2.89,1.71-5.63.24-1.31-3.43-1.31-3.43",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266.116px 119.102px"
    },
    id: "elqqgvcqoiy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,126.78s1.32,3.67,3.77,3.92,8.6.73,8.6.73",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "262.935px 129.105px"
    },
    id: "el7bhufm7w9ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,111.1l.39,5.88s2.24,1.23,7.38,1.23,6.83-1.23,6.83-1.23l-.14-5.88S255,106.69,248,111.1Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "255.3px 113.675px"
    },
    id: "eltdabqjb0xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.39,111.1l1.86,6.13s.76,1,5.91,1S282,117,282,117l-.15-5.88S274.38,106.69,267.39,111.1Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "274.695px 113.688px"
    },
    id: "ele29fpv0k58b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.49,
    y1: 111.1,
    x2: 267.39,
    y2: 111.1,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "264.94px 111.1px"
    },
    id: "elvjibgz7dkx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.03,
    y1: 111.1,
    x2: 238.37,
    y2: 116.74,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "243.2px 113.92px"
    },
    id: "elbavmpmerjhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,108.16s2.62-2.94,8.56-.49",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.69px 107.428px"
    },
    id: "ely1onvbwpdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.29,108.16a6,6,0,0,1,6.35-.73",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "271.465px 107.5px"
    },
    id: "elev2e2x4n9sv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.67,113.8c0,1.08-.39,2-.93,2s-1-.88-1-2,.39-2,.94-2S256.65,112.71,256.67,113.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.705px 113.8px"
    },
    id: "ely9coi9fwrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,113.55c0,1.08-.39,2-.93,2s-1-.88-1-2,.39-2,.93-2S272.32,112.47,272.35,113.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.385px 113.55px"
    },
    id: "elk08it121bxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,90.89S257.93,96.1,255,98a5.94,5.94,0,0,1-5.95,0,6.58,6.58,0,0,1,.19,7.44,41.31,41.31,0,0,1-5,6.69s.53,6.33-.57,7.07-4.1-.37-4.15-2.23-1.25-5.58-1.3-7.44-.91-6.7-.91-6.7-7.52-3.35-3.53-7.44,12.46-7.44,12.46-7.44.19-7.44,5.34-9.67,16.23-5.58,16.32-1.86a11.42,11.42,0,0,1-1,5.58s9.29-.37,15.77,6,6.26,12.28,2.91,12.28-4.44.74-4.44.74,6.41,3.72,3.11,5.58-6.7-.37-6.7-.37,1.42-2.6-2.76-6S255.57,90.89,255.57,90.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "260.247px 97.0919px"
    },
    id: "elo3u53yjtdzg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "124.47px 279.056px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.68,
    cy: 455.2,
    rx: 52.33,
    ry: 11.8,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "128.68px 455.2px"
    },
    id: "elee7dq74dtgn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,211.13v9.56l13.9,6.37s1.45-6.37.29-17.67Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "170.46px 218.225px"
    },
    id: "elw6eppmauf5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.15,440.54a99.64,99.64,0,0,0-9,8.77c-4,4.51-4.78,9-1.06,11.15s9.56,1.59,15.93-2.39,6.11-5.58,9.83-6.9,6.11-4,6.11-8.24-13.55-4.78-16.47-5S94.15,440.54,94.15,440.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.8221px 449.808px"
    },
    id: "eluuev6xa2gkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,442.93s-6,2.66-8.91,5.08-8.71,11.13-15.49,11.13a20.13,20.13,0,0,1-9.86-2.57,4.4,4.4,0,0,0,2.39,3.89c3.72,2.12,9.56,1.59,15.93-2.39s6.11-5.58,9.83-6.9S115.93,447.18,115.93,442.93Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.8px 452.307px"
    },
    id: "elalnvz9tjdyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.54,440.54a99.64,99.64,0,0,1,9,8.77c4,4.51,4.78,9,1.06,11.15s-9.56,1.59-15.93-2.39-6.11-5.58-9.83-6.9-6.11-4-6.11-8.24,13.55-4.78,16.47-5S161.54,440.54,161.54,440.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "156.868px 449.808px"
    },
    id: "eldh31mh4vksl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,442.93s6,2.66,8.91,5.08,8.71,11.13,15.49,11.13a20.13,20.13,0,0,0,9.86-2.57,4.4,4.4,0,0,1-2.39,3.89c-3.72,2.12-9.56,1.59-15.93-2.39s-6.11-5.58-9.83-6.9S139.76,447.18,139.76,442.93Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "156.89px 452.307px"
    },
    id: "eltjbmuf1hxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.45,289.7s1.59,59.75,2.39,68.52S92,386.9,92,388s1.32,45.15,1.32,45.15l-2.39,4,.8,5.58,10.62,2.12c5.31,1.06,12.22,2.66,13.28,1.6s1.33-3.19,1.86-6.11,1.59-8.24.53-12.48,1.33-49.4,1.6-50.46S126,332.72,126,332.72s4,35.86,6.9,46.74,1.86,27.09,2.92,33.46,3.19,27.89,3.46,29.48.79,4,.79,4,13.28-1.86,15.67-2.93a51.36,51.36,0,0,1,7.44-2.12s.79-15.14-.27-21.25a86,86,0,0,1-1.33-13c0-1.86,1.33-60.81,1.33-60.81l-1.33-57.1s-35.85,3.72-49.66,1.06S86.72,286,86.72,286Z",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.956px 366.399px"
    },
    id: "elgf8zuacmd2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,290.23C98.13,287.58,86.72,286,86.72,286l-.27,3.71s.09,3.43.24,8.75c6.33,1.77,19.19,4.88,31.62,4.88,13.14,0,34.07-4,43.49-5.91l-.2-8.25S125.75,292.89,111.94,290.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.125px 294.67px"
    },
    id: "elkqvx6qjqqvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,424.79c.17,1.83.28,2.88.28,2.88",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "158.21px 426.23px"
    },
    id: "elj9q6xdyzipk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,303.72s1,51.32,1,70.69c0,13.4,1.62,33.74,2.62,45",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.81px 361.565px"
    },
    id: "el4zz2bfq89f5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.25,
    y1: 300.82,
    x2: 102.67,
    y2: 356.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "101.46px 328.66px"
    },
    id: "elxqqsvpj3lxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.18,
    y1: 360.85,
    x2: 102.18,
    y2: 370.05,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "102.18px 365.45px"
    },
    id: "el0ut4sjlgtvwj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,149.44a8.23,8.23,0,0,0-6.67,3.47,47.27,47.27,0,0,1-5.5,6.08L78.85,171.74l2.32,90.66.87,31s18.24,6.08,35.62,6.08,48.37-7,48.37-7-2.6-120.78-1.73-120.78S147.21,156.1,139.1,152,114.77,149.44,114.77,149.44Z",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "122.44px 224.318px"
    },
    id: "elutry14ec95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,160.4s9.2,16.95,13.08,24.7S132.2,204,132.2,204l12.11-32.44",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "126.155px 182.2px"
    },
    id: "el8temxu909w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,267.91l-.47-13.53L87,252.79s.27,19.92.8,21",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "100.9px 263.29px"
    },
    id: "elh1s0p6q3gig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.13,
    y1: 277.49,
    x2: 115,
    y2: 273.69,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "115.065px 275.59px"
    },
    id: "elzc1uqoplvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.53,275.36l-.8-22.3s9.56.79,17.53-4.52",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.495px 261.95px"
    },
    id: "elwx0bn5525i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,199.92c.84,2.65,3.4,4.21,5.71,3.47s3.48-3.49,2.63-6.14-3.4-4.21-5.71-3.47S105.7,197.27,106.55,199.92Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "110.72px 198.585px"
    },
    id: "els0732sdo8ko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.82,153.52s-3.07,11.8,3.91,43.83",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "108.439px 175.435px"
    },
    id: "elxxl1lhu04lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,198.45a2.42,2.42,0,1,1-1.43-3.38A2.61,2.61,0,0,1,112.88,198.45Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "110.679px 197.375px"
    },
    id: "eldacnfq098q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,170s4.34,3.19,4.63,4.35,15.06,36.49,15.06,36.49L161.4,214l.29-20.86",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "172.115px 192px"
    },
    id: "elhn3gjmawhnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,170.58s-4.93.58-6.09,4.34-9.55,42-9.55,42L96.81,214l-2.9-28.68",
    style: {
      fill: "#5290B0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "81.46px 193.75px"
    },
    id: "eldgdnq85ohv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.05,151.72s7.61,4.34,8.36,15.14,0,13.54,0,13.54",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "145.397px 166.06px"
    },
    id: "eld8hplkprgio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,194.23s-.68,12.77-2.07,16.46-6.89,8.06-11.25,8.76",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "146.19px 206.84px"
    },
    id: "elo4pey0w2kj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,192.85s-.61,14.73-.67,17.47,2.7,7.51,6.66,12.08",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "145.66px 207.625px"
    },
    id: "elijil7x9ecff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln7ctdgmc7i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.75,
    y: 220.91,
    width: 2.69,
    height: 3.43,
    rx: 1.27,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.095px 222.625px",
      transform: "rotate(140.96deg)"
    },
    className: "animable",
    id: "el28v1347gdwb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnnn4dq6hrs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.31,
    y: 217.94,
    width: 2.69,
    height: 3.43,
    rx: 1.27,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.655px 219.655px",
      transform: "rotate(-100.73deg)"
    },
    className: "animable",
    id: "elv95gl937dma"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153,195.2l-.29-10.73a4.5,4.5,0,0,0-4.18-4.38h0a4.5,4.5,0,0,0-4.82,4.13l-.9,10.88",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "147.905px 187.639px"
    },
    id: "elyg4i4d3oj7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.91,219.82,171,218.37l-24.33-4.05-34.12-6.5-8.09-3.57s-7.65-10-8.31-11-9.31,2.49-9,3.82,1.33,14.62,2,15.46,8.14.83,8.14.83,35.64,17.2,37.12,17.83c20.57,8.67,30.49,8.59,34,9.16s5.8-.85,7.82-3.17S177.91,219.82,177.91,219.82Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "132.537px 216.774px"
    },
    id: "elphq91x2bxk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.11,193.11s-4.15.17-10.3,4.32c-2.29,1.55-3.49,2.66-3.49,3.33a10.24,10.24,0,0,0,.67,2.32,64,64,0,0,1,12.46-4.48",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "88.215px 198.095px"
    },
    id: "elonxaowdpohh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77,203.75s-11.29,2.82-13.12,3.16-2.16-1.5-2.16-2.16.5-1.67,2.49-2.66,12-3.66,12-3.66",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "89.13px 202.691px"
    },
    id: "eluv3io9qd969",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.94,208.9s-13.13,1.33-14.13.5a3.21,3.21,0,0,1-.83-2.49l11.8-2.5",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "90.4521px 207.041px"
    },
    id: "eldup8zeslxm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.28,209.56l-10.13.5s.49,1.5,1,1.66a44.4,44.4,0,0,0,7.31,1.17,34.38,34.38,0,0,1,4.82.5",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "90.715px 211.475px"
    },
    id: "elq80lp5o8vdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.48,216.34s4.63,20,5.79,21.44,10.72,0,20.28-2.9,50.11-20.27,50.11-20.27l5.79,1.15s-2.32-7.24-6.37-7.53S96.81,214,96.81,214Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "113.465px 223.282px"
    },
    id: "elhq3ogngds4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,136.69s0,.43,0,1.16c.09,3.81.46,15.91,1.43,18.83,1.16,3.47,16.8,32.73,18,30.41s8.4-33.89,8.4-33.89V140.75s-3.77,3.18-10.72,3.18S113,136.69,113,136.69Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "126.915px 161.955px"
    },
    id: "el15r6e6lkkub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,153.85a40.72,40.72,0,0,0,4.64-3.3v-9.8s-3.77,3.18-10.72,3.18S113,136.69,113,136.69s0,.43,0,1.16c0,1.34.1,3.71.22,6.35a10.14,10.14,0,0,0,.92,1.25c2,2.31,11.58,8.11,13.9,8.69S133.59,155.29,136.2,153.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "126.92px 145.723px"
    },
    id: "elin69nwcjki9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79,119.89s4.63-2.61,4.63,2.32-4.34,10.72-4.34,10.72Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "150.105px 126.065px"
    },
    id: "elert8qsx8dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.37,120.18s-6.38-1.74-6.38,4.06,5.8,9.55,5.8,9.55h4s2.32,5.8,4.35,8.11,11.58,8.11,13.9,8.69,5.5,1.16,8.11-.29a48.24,48.24,0,0,0,9-7.24c1.16-1.44,3.19-11.29,3.19-11.29s.58-17.67-.58-23.75-8.69-15.64-19.12-16.8-20.28,7.24-21.72,13.9S106.37,120.18,106.37,120.18Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.238px 121.161px"
    },
    id: "el05nsgjdelp33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.19,124.82s-2,4.05,1.45,5.21,7.82.87,8.69-.87-.58-3.76-.58-3.76",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "130.111px 127.773px"
    },
    id: "ele3j02seskhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,132.06s7.24,6.08,17.09.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "130.265px 133.455px"
    },
    id: "elcbqwvm8yleu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.77,137.56s6.09,3.48,10.14-.58",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "130.84px 137.964px"
    },
    id: "el82sta254dje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.3,
    cy: 119.02,
    rx: 1.45,
    ry: 2.32,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.3px 119.02px"
    },
    id: "elqk36azrddtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.94,118.73c0,1.28-.65,2.32-1.45,2.32s-1.45-1-1.45-2.32.65-2.31,1.45-2.31S137.94,117.45,137.94,118.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "136.49px 118.735px"
    },
    id: "el5ghujucu9ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,115.84s1.45-2.32,7-1.45",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "121.74px 115.017px"
    },
    id: "elzcaqfhtoxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17,114.68s2.61-4.06,6.67,0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "137.505px 113.778px"
    },
    id: "elljeeh7efi5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79,108a16.34,16.34,0,0,0-1.93-4.88,18.07,18.07,0,0,0-.35,4.88c.42,2.12,1.91,5.08,1.91,6.56s-.22,7.41.84,6.57a1.3,1.3,0,0,0,.25-.38A88.83,88.83,0,0,0,147.79,108Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "146.997px 112.166px"
    },
    id: "el1e55dnxjt1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,96a41.41,41.41,0,0,0,5.54-.67,21.14,21.14,0,0,0-10.1-4.06c-10.43-1.16-20.28,7.24-21.72,13.9s-.58,15.06-.58,15.06,2.3,1.6,3.15-.09,0-4.45.85-7.41,2.11-4.45,2.32-6.78-1.27-5.71-.42-7.62,6.14-5.5,9.53-4.23A29.55,29.55,0,0,0,133.23,96Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "122.443px 106.038px"
    },
    id: "elvxidrgmrw49",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.b2c0303a75cd1901bab194f54949fe98.svg";
export { ForwardRef as ReactComponent };